import axios from "axios";
import axiosInstance from "axios";

import {
  API_URL,
  DEALER_URL,
  SERVICE_HISTORY_URL,
  INVENTORY_URLS,
  CENTRAL_URLS,
  CSV_LEAD_URLS,
  ADMIN_APIKEY,
  DC_APIKEY,
  PAYMENT_API_KEY,
  AUCTION_URL,
  FCM_URL,
} from "../config";
import method from "lodash/method";

export const call = async (method, url, params = {}, data = {}, token) => {
  data = { ...data };
  const result = await axios({
    method,
    url: API_URL + url,
    params,
    data: { ...data },
    headers: {
      "Content-Type": "application/json",
      authorization: token ? `Bearer ${token}` : "",
    },
    responseType: "json",
  });

  return result;
};

export const customerCall = async (method, url, params = {}, data = {}) => {
  console.log("data ", data);
  const result = await axios({
    method,
    url: "http://localhost:8000/api/v1" + url,
    params,
    data,
    responseType: "json",
  });
  console.log("customer url", url);
  return result;
};

export const uploadedDocumentDealerApi = async (
  method,
  url,
  params = {},
  data = {},
) => {
  console.log("data ", data);
  const result = await axios({
    method,
    url: DEALER_URL + `admin-dealer-auth${url}`,
    params,
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    responseType: "json",
  });
  console.log("customer url", url);
  return result;
};

export const UpdateDealerUploadDocument = async (
  method,
  url,
  params = {},
  data = {},
) => {
  console.log("data ", data);
  const result = await axios({
    method,
    url: DEALER_URL + `admin-dealer-auth${url}`,
    params,
    data,
    headers: {
      "Content-Type": "application/json",
    },
    responseType: "json",
  });
  console.log("customer url", url);
  return result;
};

export const uploadcall = async (
  method,
  url,
  params = {},
  data = {},
  token,
) => {
  data = { ...data };
  const result = await axios({
    method,
    url: CENTRAL_URLS + url,
    params,
    data: { ...data },
    headers: {
      "Content-Type": "application/json",
      //   "Accept-Language": "en",
      authorization: token ? `Bearer ${token}` : "",
      apiKey: DC_APIKEY,
    },
    // timeout: 60000,
    responseType: "json",
  });

  return result;
};

export const brancall = async (method, url, params = {}, data = {}, token) => {
  data = { ...data };
  const result = await axios({
    method,
    url: CENTRAL_URLS + url,
    params,
    data: { ...data },
    headers: {
      "Content-Type": "application/json",
      apiKey: DC_APIKEY,
      //   "Accept-Language": "en",
      // authorization: token ? `Bearer ${token}` : "",
    },
    // timeout: 60000,
    responseType: "json",
  });

  return result;
};

export const dealerPrefrencesCall = async (method, url, data, token) => {
  try {
    console.log("🔐 [dealerPrefrencesCall] Token received:", token);
    console.log("🔐 [dealerPrefrencesCall] Token exists:", !!token);

    const headers = {
      "Content-Type": "application/json",
    };

    // Only add authorization if token exists
    if (token) {
      headers.authorization = `Bearer ${token}`;
      console.log("🔐 [dealerPrefrencesCall] Authorization header set");
    } else {
      console.warn("⚠️ [dealerPrefrencesCall] No token provided - request will be unauthorized");
    }

    console.log("📤 [dealerPrefrencesCall] Request details:", {
      method,
      url: SERVICE_HISTORY_URL + url,
      hasToken: !!token,
    });

    const result = await axios({
      method,
      url: SERVICE_HISTORY_URL + url,
      data: data,
      headers: headers,
      responseType: "json",
    });
    console.log("✅ [dealerPrefrencesCall] Response received:", result.status);
    return result.data;
  } catch (error) {
    console.error("❌ [dealerPrefrencesCall] Error:", error.response?.status, error.message);
    throw error;
  }
};

export const getDealerCallPrefrence = async (method, url, token) => {
  try {
    const result = await axios({
      method,
      url: SERVICE_HISTORY_URL + url,
      headers: {
        "Content-Type": "application/json",
        authorization: token ? `Bearer ${token}` : "",
      },
      responseType: "json",
    });
    // console.log("url ", url);
    // console.log("reslt for get pre", result.data)
    return result.data;
  } catch (error) {
    console.error("Error saving CSV list:", error);
    throw error;
  }
};

export const dealerCall = async (
  method,
  url,
  params = {},
  data = {},
  token,
) => {
  data = { ...data };
  const result = await axios({
    method,
    url: DEALER_URL + url,
    params,
    data: { ...data },
    headers: {
      "Content-Type": "application/json",
      authorization: token ? `Bearer ${token}` : "",
    },
    responseType: "json",
  });

  return result;
};

export const fcmCall = async (method, url, params = {}, data = {}, token) => {
  const result = await axios({
    method,
    url: FCM_URL + url,
    params,
    data: { ...data },
    headers: {
      "Content-Type": "application/json",
      authorization: token ? `Bearer ${token}` : "",
      "apikey": ADMIN_APIKEY,
    },
    responseType: "json",
  });

  return result;
};

export const serviceHistoryCall = async (
  method,
  url,
  params = {},
  data = {},
  token,
) => {
  data = { ...data };
  const result = await axios({
    method,
    url: SERVICE_HISTORY_URL + url,
    params,
    data: { ...data },
    headers: {
      "Content-Type": "application/json",
      //   "Accept-Language": "en",
      authorization: token ? `Bearer ${token}` : "",
    },
    // timeout: 60000,
    responseType: "json",
  });

  return result;
};

export const serviceAuction = async (
  method,
  url,
  params = {},
  data = {},
  token,
) => {
  data = { ...data };
  const result = await axios({
    method,
    url: AUCTION_URL + url,
    params,
    paramsSerializer: (params) => {
      return Object.entries(params || {})
        .filter(([, v]) => v !== undefined && v !== null)
        .map(([key, value]) => {
          if (Array.isArray(value)) {
            return `${key}=[${value.join(",")}]`;
          }
          return `${key}=${encodeURIComponent(String(value))}`;
        })
        .join("&");
    },
    data: { ...data },
    headers: {
      "Content-Type": "application/json",
      //   "Accept-Language": "en",
      authorization: token ? `Bearer ${token}` : "",
      apikey: ADMIN_APIKEY,
    },
    // timeout: 60000,
    responseType: "json",
  });

  return result;
};

export const rtoFormCall = async (
  method,
  url,
  params = {},
  data = {},
  token,
) => {
  data = { ...data };
  const result = await axios({
    method,
    url: CENTRAL_URLS + url,
    params,
    data: { ...data },
    headers: {
      "Content-Type": "application/json",
      apiKey: DC_APIKEY,
      //   "Accept-Language": "en",
      authorization: token ? `Bearer ${token}` : "",
    },
    // timeout: 60000,
    responseType: "json",
  });

  return result;
};

export const inventoryCreate = async (
  method,
  url,
  params = {},
  data,
  token,
) => {
  try {
    const result = await axiosInstance({
      method,
      url: CENTRAL_URLS + url,
      params,
      data,
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        apikey: DC_APIKEY,
      },
    });
    return result.data;
  } catch (error) {
    if (error.response) {
    } else if (error.request) {
      console.error("Request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);

    throw error;
  }
};

export const saveCsvList = async (method, url, formData, token) => {
  try {
    const result = await axios({
      method,
      url: SERVICE_HISTORY_URL + url,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        authorization: token ? `Bearer ${token}` : "",
      },
      responseType: "json",
    });
    return result.data;
  } catch (error) {
    console.error("Error saving CSV list:", error);
    throw error;
  }
};

export const multiBrandcall = async (method, url, data) => {
  const result = await axios({
    method,
    url: CENTRAL_URLS + url,
    data: data,
    headers: {
      "Content-Type": "application/json",
      apikey: ADMIN_APIKEY,
    },
    // timeout: 60000,
    responseType: "json",
  });

  return result;
};

export const saveCsvFileData = async (method, url, data, token) => {
  try {
    const result = await axios({
      method,
      url: SERVICE_HISTORY_URL + url,
      data: data,
      headers: {
        "Content-Type": "application/json",
        authorization: token ? `Bearer ${token}` : "",
      },
      responseType: "json",
    });
    return result.data;
  } catch (error) {
    console.error("Error saving CSV list:", error);
    throw error;
  }
};

export const updateCsvStatus = async (method, url, token) => {
  try {
    const result = await axios({
      method,
      url: SERVICE_HISTORY_URL + url,
      headers: {
        "Content-Type": "application/json",
        authorization: token ? `Bearer ${token}` : "",
      },
      responseType: "json",
    });
    return result.data;
  } catch (error) {
    console.error("Error saving CSV list:", error);
    throw error;
  }
};

export const carList = async (method, url, params = {}, data = {}, token) => {
  const requestData = { ...params, ...data };
  const result = await axios({
    method,
    url: CENTRAL_URLS + url,
    data: requestData,
    headers: {
      "Content-Type": "application/json",
      authorization: token ? `Bearer ${token}` : "",
      apiKey: DC_APIKEY,
    },
    responseType: "json",
  });

  return result;
};

export const multuModelList = async (
  method,
  url,
  params = {},
  data = {},
  token,
) => {
  const result = await axios({
    method,
    url: CENTRAL_URLS + url,
    params: { ...params }, // make and is_group_model will be sent as query params
    headers: {
      "Content-Type": "application/json",
      apikey: ADMIN_APIKEY,
    },
    responseType: "json",
  });

  return result;
};

export const csvList = async (method, url, params = {}, data = {}, token) => {
  data = { ...data };
  const result = await axios({
    method,
    url: SERVICE_HISTORY_URL + url,
    params,
    data: { ...data },
    headers: {
      "Content-Type": "application/json",
      authorization: token ? `Bearer ${token}` : "",
    },
    responseType: "json",
  });
  return result;
};

export const templateCall = async (method, url) => {
  const result = await axios({
    method,
    url: DEALER_URL + "admin-dealer-auth/" + url,
    headers: {
      "Content-Type": "application/json",
    },
    responseType: "json",
  });
  return result;
};

export const uplodTemplate = async (method, url, formData) => {
  const result = await axios({
    method,
    url: DEALER_URL + "admin-dealer-auth" + url,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: formData,
    responseType: "json",
  });
  return result;
};

export const templateDetails = async (method, url, params = {}, token) => {
  const result = await axios({
    method,
    url: DEALER_URL + "admin-dealer-auth/" + url,
    params,
    headers: {
      "Content-Type": "application/json",
      authorization: token ? `Bearer ${token}` : "",
    },
    responseType: "json",
  });
  return result;
};

export const customerCalls = async (
  method,
  url,
  params = {},
  data = {},
  token,
) => {
  const result = await axios({
    method,
    url: SERVICE_HISTORY_URL + "admin/buyer-lead/" + url,
    params,
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      "Content-Type": "application/json",
    },
    data: { ...data },
    responseType: "json",
  });
  return result;
};

export const preferenceCall = async (method, url, params, token) => {
  const fullUrl = `${SERVICE_HISTORY_URL}admin/buyer-lead/${url}/${params}`;
  const result = await axios({
    method,
    url: fullUrl,
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      "Content-Type": "application/json",
    },
    responseType: "json",
  });
  return result;
};

export const addManageStore = async (method, url, data, params = {}) => {
  const config = {
    method,
    url: DEALER_URL + "admin-dealer-auth/" + url,
    params,
    headers: {
      "Content-Type": "application/json",
    },
    responseType: "json",
  };

  // Only add the `data` field if the method is not GET
  if (method.toLowerCase() !== "get") {
    config.data = data; // Attach data to POST, PUT, etc.
  } else {
    config.params = { ...params, ...data }; // Attach data as query params for GET
  }

  const result = await axios(config);
  return result;
};

export const getState = async (method, url) => {
  const result = await axiosInstance({
    method,
    url: `${CENTRAL_URLS}inventoryService/public/${url}`,
    headers: {
      apikey: ADMIN_APIKEY,
    },
  });
  return result;
};

export const getCity = async (method, url, { params }) => {
  console.log(params);
  const result = await axiosInstance({
    method,
    url: `${CENTRAL_URLS}inventoryService/public/${url}`,
    headers: {
      apikey: ADMIN_APIKEY,
    },
    params,
  });
  return result;
};

export const carCall = async (method, url, params = {}, data, token) => {
  const result = await axiosInstance({
    method,
    url: CENTRAL_URLS + url,
    data: data,
    headers: {
      "Content-Type": "application/json",
      "Accept-Language": "en",
      authorization: token ? `Bearer ${token}` : "",
      apikey: DC_APIKEY,
    },

    // timeout: 60000,
  });
  return result;
};

export const uploadImage = async (method, url, params = {}, data, token) => {
  const result = await axiosInstance({
    method,
    url: CENTRAL_URLS + url,
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": "en",
      authorization: token ? `Bearer ${token}` : "",
      apikey: DC_APIKEY,
    },

    // timeout: 60000,
  });
  return result;
};

export const serviceRtoCall = async (
  method,
  url,
  params = {},
  data = {},
  token,
) => {
  data = { ...data };
  const result = await axios({
    method,
    url: SERVICE_HISTORY_URL + url,
    params,
    data: { ...data },
    headers: {
      "Content-Type": "application/json",
      //   "Accept-Language": "en",
      authorization: token ? `Bearer ${token}` : "",
    },
    // timeout: 60000,
    responseType: "json",
  });

  return result;
};

export const transactionDetails = async (method, url, data, token) => {
  const result = await axios({
    method,
    url: SERVICE_HISTORY_URL + url,
    data,
    headers: {
      "Content-Type": "application/json",
      authorization: token ? `Bearer ${token}` : "",
      apikey: DC_APIKEY,
    },
    responseType: "json",
  });
  return result;
};
